import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDqEhtbatlJ4TMrwvU5aigGgqB2hzFGWys",
  authDomain: "incentiveschoolfront.firebaseapp.com",
  projectId: "incentiveschoolfront",
  storageBucket: "incentiveschoolfront.firebasestorage.app",
  messagingSenderId: "581389364561",
  appId: "1:581389364561:web:dcd55f5515dccacdfc7770"
};

const firebaseApp = initializeApp(firebaseConfig);

let messaging = null;

async function initMessaging() {
  const supported = await isSupported();
  if (supported) {
    messaging = getMessaging(firebaseApp);
    console.log("Firebase messaging initialized.");
  } else {
    console.warn("Firebase messaging is not supported in this browser.");
  }
}

initMessaging();

export { messaging, getToken, onMessage, isSupported };
